import { createFileRoute } from "@tanstack/react-router"

import { PrivacyPolicyRouteComponent } from "@/routes/privacy-policy"

export const Route = createFileRoute("/qr/$qrLookupID/privacy-policy")({
  staticData: {
    pageName: "Privacy Policy",
  },
  component: PrivacyPolicyRouteComponent,
})
